import { Box, Checkbox, FormControl, TextInput } from '@primer/react';
import { PersonIcon } from '@primer/octicons-react'
import { useEffect, useState } from 'react';
import { crmHocSinhApi } from '../../../api/crmHocSinhApi';
import Button from '../../../components/ui/button';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { IStudentBaseInformation } from '../../../models/request/acceptance-form/IStudentBaseInformation';
import { crmHocSinhBHYTApi } from '../../../api/crmHocSinhBHYTApi';
import FormBlock from '../profile-form/FormBlock';
import { IHocSinhBHYT, IHocSinhBHYTResponse } from '../../../models/response/crm-hocsinh/IHocSinhBHYTResponse';
import { Controller, useForm } from 'react-hook-form';
import { NotifyHelper } from '../../../helpers/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBus, faClock, faCoffee, faMapMarker, faMapPin, faRetweet, faRoad, faUser } from '@fortawesome/free-solid-svg-icons';
import { busApi } from '../../../api/busApi';

export interface IBHYTProps {
    ts_hocsinh_id: number;
}

const BusPage = (props: IBHYTProps) => {
    const [dangKyBus, setDangKyBus] = useState<any>();
    useEffect(() => {
        handleGetBHYTData();
    }, [props.ts_hocsinh_id]);

    const handleGetBHYTData = async () => {
        const res = await busApi.selectByHocSinh(props.ts_hocsinh_id);
        if (res.is_success) {
            setDangKyBus(res.data);
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }
    };

    return (
        <Box sx={{ padding: 0 }}>
            <Box sx={{ display: "flex", gap: 3 }}>
                <Box sx={{ flex: 1 }}>
                    <Box
                        sx={{
                            border: "1px solid",
                            borderColor: "border.default",
                            borderRadius: 2,
                            maxHeight: "calc(100vh - 390px)",
                            overflowY: "auto",
                        }}
                    >

                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon style={{
                                backgroundColor: "rgb(227, 242, 253)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(33, 150, 243)"
                            }} icon={faUser} />
                             <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Họ tên:</span> {dangKyBus?.ts_hocsinh_hoten } ({dangKyBus?.ma_hs})
                            <Box sx={{ 
                                display: "flex", 
                                alignItems: "center", 
                                gap: 1, 
                                padding: "0px 5px",
                                 border: "1px solid rgb(165, 214, 167)", 
                                 borderRadius: "15px", 
                                 backgroundColor: "rgb(237, 247, 237)",
                                 color: "rgb(30, 70, 32)"
                                 }}>
                                <FontAwesomeIcon icon={faClock} /> {dangKyBus?.bus_trangthai}
                            </Box>
                        </Box>
                        {dangKyBus?.bus_trangthai === "Đã xếp tuyến" && (
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon style={{
                                backgroundColor: "rgb(227, 242, 253)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(33, 150, 243)"
                            }} icon={faRoad} />
                             <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Tuyến:</span> {dangKyBus?.ma_tuyen } - {dangKyBus?.ten_tuyen }  
                             <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>(Monitoring:</span> {dangKyBus?.bus_monitoring_hoten } -
                                <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Lái xe:</span> {dangKyBus?.bus_laixe_hoten })
                        </Box>
                        )}
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon 
                           style={{
                                backgroundColor: " rgb(237, 231, 246)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(103, 58, 183)"
                            }}
                            icon={faBus} /> 	
                            <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Hình thức đăng ký:</span> 
                             <Box sx={{ 
                                display: "flex", 
                                alignItems: "center", 
                                gap: 1, 
                                padding: "0px 5px",
                                 border: "1px solid rgb(165, 214, 167)", 
                                 borderRadius: "15px", 
                                 backgroundColor: "rgb(237, 247, 237)",
                                 color: "rgb(30, 70, 32)"
                                 }}>
                                <FontAwesomeIcon icon={faRetweet} /> {dangKyBus?.hinh_thuc}
                            </Box>
                            
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon   style={{
                                backgroundColor: "rgb(227, 242, 253)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(255, 152, 0)"
                            }}
                            icon={faBus} /> 	
                            <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Hình thức đón trả:</span>   
                            {dangKyBus?.bus_hinhthuc_dontra}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon style={{
                               backgroundColor: "rgb(227, 242, 253)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(33, 150, 243)"
                            }}
                            icon={faBus} /> 	
                            <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Loại điểm đón:</span>   
                            {dangKyBus?.bus_loaidiemdon_name}
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon
                            style={{
                               backgroundColor: "rgb(232, 245, 233)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(76, 175, 80)"
                            }}
                            icon={faMapMarker} />
                             <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Điểm đón:</span> 
                             {dangKyBus?.diachi_diemdon}
                             </Box>
                        <Box sx={{display: "flex", alignItems: "center", gap: 2, padding: 2}}>
                            <FontAwesomeIcon 
                            style={{
                               backgroundColor: "rgb(255, 235, 238)",
                                padding: "3px",
                                borderRadius: "3px",
                                color: "rgb(244, 67, 54)"
                            }}
                            icon={faMapMarker} />
                            <span style={{color: "rgb(117, 117, 117)", fontSize: "0.9em"}}>Điểm trả:</span> 
                            {dangKyBus?.diachi_diemtra}
                            </Box>
                    </Box>
                </Box>
                <Box sx={{ flex: 1 }} >
                    <Box
                        sx={{
                            border: "1px solid",
                            borderColor: "border.default",
                            borderRadius: 2,
                            maxHeight: "calc(100vh - 420px)",
                            overflowY: "auto",
                        }}
                    >
                        <Box
                            sx={{
                                bg: "canvas.subtle",
                                p: 2,
                                borderBottom: "1px solid",
                                borderColor: "border.default",
                                fontWeight: "bold",
                                color: "fg.muted",
                            }}
                        >
                            Danh sách điểm danh bus hàng ngày
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default BusPage;
